import { render } from "./Chapters.vue?vue&type=template&id=3ffddf95"
import script from "./Chapters.vue?vue&type=script&lang=js"
export * from "./Chapters.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__